import {api} from '../../utils/api'

export default {

    /**
     * load injectors
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadInjectors({commit}, injID) {
        return api.call(commit, 'get', '/api/injector/'+injID, null,  'SET_INJECTORS');
    },

    /**
     * Update injectors
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    updateInjector({commit}, payload) {
        return api.call(commit, 'patch', '/api/injector/' + payload.id, api.cleanTaskInstances(["task_id", "task_source_id"], payload), 'SET_INJECTORS');
    },

    /**
     * Delete injectors
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    deleteInjector({commit}, payload) {
        return api.call(commit, 'delete', '/api/injector/' + payload.id, null, 'DELETE_INJECTORS');
    },

    /**
     * create new injector
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    createInjector({commit}, payload) {
        // Create new field
        return api.call(commit, 'post', '/api/injector/', payload, 'SET_INJECTORS');
    },


}
